module.exports = __webpack_public_path__ + "img/worry-adviser.8f4f31f.jpg";